import { updateIOSSettings } from '../../../actions/siteadmin/ConfigSettings/updateIOSSettings';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const fields = [
    'recommendOrder',
    'placesOrder',
    'bannerOrder',
    'mostViewedOrder'
  ];

  const orderValues = fields
    .map(field => Number(values[field]))
    .filter(val => !isNaN(val) && val > 0);

  const valueSet = new Set(orderValues);

  if (valueSet.size !== orderValues.length) {
    showToaster({ messageId: 'duplicateOrder', toasterType: 'error' });
    return;
  }

  await dispatch(updateIOSSettings(values));
}

export default submit;
